var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'vue-property-decorator';
let Login = class Login extends Vue {
    constructor() {
        super(...arguments);
        this.loginWithEmail = true;
        this.code = '';
    }
    mounted() {
        if (this.display !== null && this.display !== '') {
            this.loginWithEmail = this.display === 'email';
        }
        document.addEventListener('keydown', this.keydown);
    }
    beforeDestroy() {
        document.removeEventListener('keydown', this.keydown);
    }
    keydown(event) {
        if (this.loginWithEmail) {
            return;
        }
        switch (event.keyCode) {
            case 13:
                event.preventDefault();
                const form = document.querySelector('form.login-form');
                form === null || form === void 0 ? void 0 : form.submit();
                break;
            case 8:
            case 46:
                event.preventDefault();
                this.removeLast();
                break;
            default:
                const num = Number.parseInt(event.key);
                if (!Number.isNaN(num)) {
                    event.preventDefault();
                    this.add(num);
                }
                break;
        }
    }
    add(number) {
        this.code += `${number}`;
    }
    removeLast() {
        this.code = this.code.slice(0, -1);
    }
    get displayCode() {
        return this.code.replace(/[0-9]/g, '*');
    }
};
__decorate([
    Prop()
], Login.prototype, "loginUrl", void 0);
__decorate([
    Prop()
], Login.prototype, "resetUrl", void 0);
__decorate([
    Prop()
], Login.prototype, "emailError", void 0);
__decorate([
    Prop()
], Login.prototype, "passwordError", void 0);
__decorate([
    Prop()
], Login.prototype, "oldEmail", void 0);
__decorate([
    Prop()
], Login.prototype, "display", void 0);
Login = __decorate([
    Component
], Login);
export default Login;
